

export const techsMastered = [
  {
    name: "html",
    title: "HTML 5",
    url: "https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/html5-colored.svg"
  },
  {
    name: "css",
    title: "CSS 3",
    url: "https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/css3-colored.svg"

  },
  {
    name: "js",
    title: "JAVASCRIPT",
    url: "https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/javascript-colored.svg"

  },
  {
    name: "react",
    title: "REACT",
    url: "https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/react-colored.svg"

  },
  {
    name: "styled-components",
    title: "STYLED-COMPONENTS",
    url: "https://cdn.simpleicons.org/styledcomponents"


  },
  {
    name: "redux",
    title: "Redux",
    url: "https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/redux-colored.svg"

  },
  {
    name: "jquery",
    title: "jquery",
    url: "https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/jquery-colored.svg"

  },
  {
    name: "socket",
    title: "socket IO",
    url: "https://cdn.simpleicons.org/socket.io/white"

  },

  {
    name: "node",
    title: "NODE JS",
    url: "https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/nodejs-colored.svg"

  },
  {
    name: "express",
    title: "Express",
    url: "https://cdn.simpleicons.org/express/white"

  },

  {
    name: "PostgreSQL",
    title: "PostgreSQL",
    url: "https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/postgresql-colored.svg"

  },


  {
    name: "mongo",
    title: "MONGO DB",
    url: "https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/mongodb-colored.svg"

  },

  {
    name: "mongoose",
    title: "mongoose",
    url: "https://cdn.simpleicons.org/mongoose"

  },
  {

    title: "FIREBASE",
    name: "fire",
    url: "https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/firebase-colored.svg"

  },



  {
    name: "electron",
    title: "Electron",
    url: "https://cdn.simpleicons.org/electron/#47848F"

  },
  {

    name: "typeScript",

    title: "TypeScript",

    url: "https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/typescript-colored.svg"

  },

  {

    name: "react",

    title: "React Native",

    url: "https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/react-colored.svg"

  },



  {

    name: "next",

    title: "Next JS",

    url: "https://cdn.simpleicons.org/nextdotjs/white"

  },
  {

    name: "tailwindcss",

    title: "Tailwind CSS",

    url: "https://cdn.simpleicons.org/tailwindcss/#06B6D4"

  }




]

export const techsStudying = [
  {
    name: "php",
    title: "PHP",
    url: "https://cdn.simpleicons.org/php/#777BB4"
  },
  {

    name: "laravel",
    title: "LARAVEL",
    url: "https://cdn.simpleicons.org/laravel/#FF2D20"

  },
  {



    name: "mysql",

    title: "MySQL",

    url: "https://cdn.simpleicons.org/mysql/#4479A1"



  }


]